module.exports = __webpack_public_path__ + "static/img/bgr.3799ac03.png";